import { Provider } from "@angular/core";
import { NarikDialogOverlayContainerComponent } from "./components/narik-dialog-overlay-container/narik-dialog-overlay-container.component";

export const COMPONENTS: Provider[] = [NarikDialogOverlayContainerComponent];
export const ENTRY_COMPONENTS: Provider[] = [
  NarikDialogOverlayContainerComponent
];
export const EXPORT_COMPONENTS: Provider[] = [
  NarikDialogOverlayContainerComponent
];
